import React from 'react'
import { Helmet } from 'react-helmet'

const uitest = () => {
  return (
    <div>
      <Helmet>Warning! - Ui Test Page</Helmet>
    </div>
  )
}

export default uitest
